<template>
    <div class="main-box product-detail" :class="{'mask-layer':addSucceed}">
        <div class="box-header">
            <i class="el-icon-close" @click="$emit('close','productBuy')"></i>
            <span>Product Details </span>
        </div>
        <div class="box-content" :class="{isDiscussion:isDiscussion}">
            <scroll-wrap id="productBuy">
                <div class="box-content-wrap">
                    <div class="imglist">
                        <el-carousel trigger="click" height="328px">
                            <el-carousel-item v-for="item in product.attachments" :key="item">
                                <img :src="item" alt="">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="title">
                        {{product.title}}
                    </div>
                    <div class="store">
                        Sold By
                    </div>
                    <div class="store-name">
                        <img src="./../../assets/images/store.png" alt="" width="34" height="34">
                        <span>{{product.shop.storeName}}</span>
                    </div>
                    <div class="product-info">
                        <el-collapse v-model="collapseIndex">
                            <el-collapse-item name="1">
                                <div slot="title">
                                    <span style="padding-left: 8px">
                                        Description
                                    </span>
                                </div>
                                <div class="collapse-item-txt">
                                    <pre style="white-space: pre-wrap;margin: 0;font-family: inherit;padding: 0 8px">{{product.description}}</pre>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item name="2">
                                <div slot="title">
                                    <span style="padding-left: 8px">
                                        Countries & Festivals
                                    </span>
                                </div>
                                <div class="collapse-item-txt" style="padding: 0 10px">
                                    <div class="State-Religion">
                                        <h3>Countries</h3>
                                        <div>
                                            <span v-for="(item,index) in product.suitCountry"
                                                  :key="`suitFestival_${index}`">
                                                {{item}}
                                            </span>
                                            <span v-if="product.suitCountry.length===0">
                                                For all countries
                                            </span>
                                        </div>
                                        <h3>Festivals</h3>
                                        <div>
                                            <span v-for="(item,index) in product.suitFestival" :key="index">
                                                {{item}}
                                            </span>
                                            <span v-if="product.suitFestival.length===0">
                                                Suitable for all festivals
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </scroll-wrap>
            <div class="message-alert" :class="{'active':addSucceed}">
                <div class="img">
                    <img :src="product.image" alt="">
                </div>
                <div class="txt">
                    Items Added to Cart
                </div>
                <div class="price">
                    You saved ${{product.price}}
                </div>
            </div>
        </div>
        <div class="box-footer">
            <div class="send-wrap" :class="{isDiscussion:isDiscussion}">
                <input type="text" v-model="message">
                <i class="el-icon-s-promotion" @click="sendDiscuss"></i>
            </div>
            <div class="buy-wrap">
                <div class="price-wrap">
                    <span class="price" v-if="product.status!==2">${{product.price}}</span>
                    <span class="price" v-else-if="(Date.now()> product.startTime )&&(Date.now()<product.endTime)">${{product.promotionPrice}}</span>
                    <span class="price" v-else>${{product.price}}</span>

                    <span class="msrp" v-if="product.status!==2">${{product.msrp}}</span>
                    <span class="msrp" v-else-if="(Date.now()> product.startTime )&&(Date.now()<product.endTime)">${{product.price}}</span>
                    <span class="msrp" v-else>${{product.msrp}}</span>
                </div>
                <div class="buy-btn">
                    <span @click="buy">
                        Buy
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Product-Buy",
        props: {
            getProductBuy: [Object],
        },
        computed: {
            product: function () {
                return this.getProductBuy
            }
        },
        data() {
            return {
                collapseIndex: ['1','2'],
                addSucceed: false,
                isDiscussion: false,
                message: '',
                discussionGroup: {}
            }
        },
        created() {

        },
        methods: {
            buy() {
                this.axios.post('/student/buyer/order/cart/append', {
                    product: {id: this.product.id},
                    amount: 1
                }).then(res => {
                    if (res.succeed) {
                        this.addSucceed = true;
                        setTimeout(() => {
                            this.addSucceed = false;
                        }, 2000)
                    }
                })
            },
            discuss() {
                let params = {
                    discuss: {
                        product: {
                            id: this.product.id
                        }
                    }
                }
                this.axios.post('/student/discuss/product/list', params).then(res => {
                    if (res.succeed) {
                        this.discussionGroup = res.items;
                        this.$nextTick(() => {
                            setTimeout(() => {
                                document.querySelector("#productBuy").children[0].scrollTop =
                                    document.querySelector("#productBuy").children[0].scrollHeight -
                                    document.querySelector("#productBuy").children[0].clientHeight
                            }, 10)

                        })
                    }
                })
            },
            sendDiscuss() {
                if (this.message.trim() === '') return false
                let params = {
                    product: {
                        id: this.product.id
                    },
                    type: 2,
                    message: this.message
                }
                this.axios.post('/student/discuss/product/uploader', params).then(res => {
                    if (res.succeed) {
                        this.message = ""
                        this.discuss()
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box.product-detail {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 2001;
        }

        div.box-header {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 52px;
            line-height: 52px;

            > i {
                position: absolute;
                top: 50%;
                left: 0;
                font-weight: bolder;
                transform: translateY(-50%);
                font-size: 18px;
                padding: 10px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }
            }

            > span {
                font-size: 18px;
                color: #000000;
                font-weight: bolder;
            }
        }

        div.box-content {
            position: relative;
            height: calc(100% - 103px);

            &.isDiscussion {
                height: calc(100% - 171px);
            }

            div.box-content-wrap {
                div.imglist {
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                div.title {
                    padding: 12px;
                    font-size: 14px;
                    margin-bottom: 8px;
                }

                div.store {
                    padding: 14px 8px;
                    background: #EEF6F8;
                    font-weight: bolder;
                    font-size: 16px;
                }

                div.store-name {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    font-weight: bolder;
                    padding: 10px 8px;

                    img {
                        margin-right: 10px;
                    }

                    span {
                        word-break: break-all;
                    }
                }

                div.product-info {
                    .collapse-item-txt {
                        padding: 0 8px;
                        div.discussion-group {
                            div.group-content {
                                > div.item {
                                    display: flex;
                                    padding: 0 8px;
                                    box-sizing: border-box;
                                    margin-bottom: 8px;

                                    div.item-portrait {
                                        width: 48px;
                                        height: 48px;
                                        border-radius: 50%;
                                        overflow: hidden;
                                        margin-right: 16px;

                                        img {
                                            width: 100%;
                                            height: 100%;
                                            object-fit: cover;
                                        }
                                    }

                                    div.item-content {
                                        display: flex;
                                        flex-direction: column;
                                        width: 70%;

                                        > .sayer-name {
                                            font-size: 12px;
                                        }

                                        > .sayer-txt {
                                            background-color: #EFF1F5;
                                            border-radius: 6px;
                                            padding: 12px;
                                            word-break: break-all;
                                        }
                                    }
                                }
                            }

                            div.group-footer {
                                input {
                                    outline: none;

                                }
                            }
                        }
                        div.State-Religion {
                            padding: 0 8px;
                            h3 {
                                margin: 4px 0;
                            }
                            span {
                                background: #ABD5DB;
                                padding: 4px 8px;
                                border-radius: 4px;
                            }
                        }
                    }
                }

            }

            div.message-alert {
                width: 100%;
                padding: 20px 0;
                background: #FFFFFF;
                position: absolute;
                bottom: -300px;
                left: 0;
                z-index: 9999;
                transition: bottom 0.3s linear;
                border-radius: 0 0 22px 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &.active {
                    bottom: -52px;
                    transition: bottom 0.3s linear;
                }

                > .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 20px;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                > .txt {
                    font-weight: bolder;
                    margin-bottom: 10px;
                }

                > .price {
                    font-weight: lighter;
                    font-size: 12px;
                }
            }
        }

        div.box-footer {
            position: relative;

            div.send-wrap {
                width: 100%;
                height: 68px;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                background: #FFFFFF;
                border-radius: 0 0 20px 20px;
                border-top: 1px solid #EBEEF5;
                position: absolute;
                top: 100%;
                left: 0;
                z-index: -1;
                transition: top 0.3s ease-in-out;

                &.isDiscussion {
                    transition: top 0.3s ease-in-out;
                    position: relative;
                    top: 0;
                    z-index: 1;
                }

                > input {
                    width: 80%;
                    outline: none;
                    border: none;
                    background: #F1F1F1;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 36px;
                    margin-right: 2%;
                    font-size: 12px;
                    padding: 0 16px;
                    box-sizing: border-box;
                }

                > i {
                    width: 36px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    color: #ffffff;
                    background: #FDAD53;
                    cursor: pointer;
                    border-radius: 50%;
                    transition: background-color 0.3s ease-in-out;

                    &:hover {
                        background: #F44336;
                        transition: background-color 0.3s ease-in-out;
                    }
                }
            }

            div.buy-wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 12px;
                box-sizing: border-box;
                height: 52px;
                border-top: 1px solid #dee1e9;

                div.price-wrap {
                    span.price {
                        color: #F44336;
                        font-weight: bolder;
                        font-size: 22px;
                    }

                    span.msrp {
                        text-decoration: line-through;
                        color: #9F9FA0;
                        font-size: 14px;
                    }
                }

                div.buy-btn {
                    span {
                        color: #FFFFFF;
                        font-weight: bolder;
                        font-size: 18px;
                        border-radius: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100px;
                        height: 36px;
                        background: #FDAD53;
                        cursor: pointer;
                        transition: background 0.3s linear;

                        &:hover {
                            background: #ff8700;
                            transition: background 0.3s linear;
                        }
                    }
                }
            }
        }
    }
</style>
